import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4 12h6l-6 8h6","key":"svg-0"}],["path",{"d":"M14 4h6l-5.146 6.862m1.146 1.138h4","key":"svg-1"}],["path",{"d":"M3 3l18 18","key":"svg-2"}]]

/**
 * IconZzzOff
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItenp6LW9mZiIKPgogIDxwYXRoIHN0cm9rZT0ibm9uZSIgZD0iTTAgMGgyNHYyNEgweiIgZmlsbD0ibm9uZSIgLz4KICA8cGF0aCBkPSJNNCAxMmg2bC02IDhoNiIgLz4KICA8cGF0aCBkPSJNMTQgNGg2bC01LjE0NiA2Ljg2Mm0xLjE0NiAxLjEzOGg0IiAvPgogIDxwYXRoIGQ9Ik0zIDNsMTggMTgiIC8+Cjwvc3ZnPg==) - https://tabler.io/icons/icon/zzz-off
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconZzzOff = createReactComponent('outline', 'zzz-off', 'ZzzOff', __iconNode);

export default IconZzzOff;